import { Map } from 'immutable';

import {
	FETCH_STARTED,
	FETCH_COMPLETED,
	SET_FINGERPRINT,
	SET_CONTACT_INFO,
	SET_MESSAGE
} from './actionDefinitions';

const appInitialState = new Map({
	isFetching: false,
	hasProfile: null,
	email: '',
	message: new Map({
		show: false,
		type: ''
	})
});

const app = (state = appInitialState, action) => {
	switch(action.type) {
		case FETCH_STARTED:
			return state.merge({ isFetching: true });
		case FETCH_COMPLETED:
			return state.merge({ isFetching: false });
		case SET_CONTACT_INFO:
			return state.set('hasProfile', action.payload.hasProfile).set('email', action.payload.email);
		case SET_MESSAGE:
			return state.setIn(['message', 'show'], true).setIn(['message', 'type'], action.payload.type);
		case SET_FINGERPRINT:
			return state.set('contractinfo', action.payload.fingerprint);
		default:
			return state;
	}
};

export default app;
